import React from "react";
import {
  ICON_PATHS,
  VIEWBOX_SIZE,
} from "common-client/utils/objectTypePreviewIcon/iconPaths";
import { PointIconProps } from "common-client/utils/objectTypePreviewIcon/types";

const PointIcon = ({
  iconType,
  fillColor,
  fillOpacity,
  lineColor,
  size = 16,
}: PointIconProps) => {
  const paths = ICON_PATHS[iconType];

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      fill="none"
      style={{ filter: "drop-shadow(0px 1px 1.5px rgba(0, 0, 0, 0.2))" }}
    >
      <path
        d={paths.filled}
        fill={fillColor}
        fillOpacity={fillOpacity}
        stroke={lineColor}
        strokeWidth={2}
      />
      {paths.innerDetail && (
        <path
          d={paths.innerDetail}
          fill={lineColor}
          stroke={lineColor}
          strokeWidth={1.5}
          strokeLinecap="round"
        />
      )}
    </svg>
  );
};

export default PointIcon;
